import fetchLocationConfig from 'widget/utils/services/fetchLocationConfig';
import invariant from 'invariant';
import logger, { CONTEXTS } from 'widget/logger';
import { AdobeAnalyticsConfig } from 'widget/types/widgetTrackingConfig';
import { merge } from 'lodash-es';
import { Session } from 'widget/utils/session';
import { TransportInterface } from 'widget/utils/transport/types';

/**
 * Save analytics config to window
 *
 * If sessionId and profileId exist, it will fetch
 * subscription data as well.
 */
export default async function saveAnalyticsConfigToWindow(
  session: Session,
  ampUrl: string,
  configEnv: string,
  countryCode: string,
  transport: TransportInterface,
  adobeAnalyticsConfig: AdobeAnalyticsConfig
) {
  invariant(__CLIENT__, 'cannot call saveAnalyticsConfigToWindow() on server');
  const { profileId, sessionId } = await session.getSession();
  let user = {};

  if (profileId && sessionId) {
    try {
      const { subscription } = await fetchLocationConfig({
        ampUrl,
        configEnv,
        countryCode,
        logger,
        profileId,
        sessionId,
        transport,
      });

      user = {
        isTrialEligible: subscription!.isTrialEligible.toString(),
        profileId,
        skuPromotionType: subscription!.productId,
        subscriptionTier: subscription!.subscriptionType,
      };
    } catch (error: any) {
      const errObj =
        error instanceof Error
          ? error
          : new Error(error?.message ?? 'Could not fetch location config.');
      logger.error(CONTEXTS.REACT, errObj.message, {}, errObj);
    }
  }

  window.analyticsData = merge({}, adobeAnalyticsConfig, {
    global: {
      user,
    },
  });
}
